import { RequestResponse } from '@core/services/request/model/request.model';
import { OriginWarrantyApi, OriginWarrantyApiRequest } from '@core/api/model/sustainability/origin-warranty-api.model';
import { OriginWarranty, OriginWarrantyFilters } from '@core/domain/model/sustainability/origin-warranty.model';
import { MasterSocietyModel } from '@core/domain/model/master/master-society.model';
import { MasterInstallationModel } from '@core/domain/model/master/master-installation.model';
import { filterArrNil } from '@shared/utils/filter-array-nil';

export class OriginWarrantyMapper {
  static requestFromApiToDomain(
    input: RequestResponse<OriginWarrantyApi>,
    societies: MasterSocietyModel[],
    installations: MasterInstallationModel[]
  ): RequestResponse<OriginWarranty> {
    return {
      ...input,
      data: OriginWarrantyMapper.fromApiToDomain(input.data, societies, installations),
    };
  }

  static fromApiToDomain(
    api: OriginWarrantyApi,
    societies: MasterSocietyModel[],
    installations: MasterInstallationModel[]
  ): OriginWarranty {
    const societiesGrouped = new Map<string, MasterSocietyModel>();
    const installationsGrouped = new Map<string, MasterInstallationModel>();
    societies.forEach((society) => {
      societiesGrouped.set(society.codigo, society);
    });
    installations.forEach((installation) => {
      installationsGrouped.set(installation.cups, installation);
    });
    return {
      totalGreenConsumption: api.totalConsumoVerde,
      installations: api.instalaciones
        .map((value) => {
          const installation = installationsGrouped.get(value.cups);
          if (!installation) {
            return null;
          }
          const society = societiesGrouped.get(installation.codigoRazonSocial);
          if (!society) {
            return null;
          }
          return {
            cups: value.cups,
            societyName: society.nombre,
            societyCode: society.numDocumento,
            installationName: installation.nombre,
            greenConsumption: value.consumoVerde,
          };
        })
        .filter(filterArrNil),
    };
  }

  public static requestFromDomainToApi(filters: OriginWarrantyFilters): OriginWarrantyApiRequest {
    return {
      listaCups: filters.cups?.map((i) => ({ cups: i.cups, nombreInstalacion: i.nombre, tarifa: i.tariff })) ?? [],
      // Add 1 to send the months from 1 to 12 (filters come from 0 to 11)
      mes: filters?.month != undefined ? filters.month + 1 : undefined,
      anio: filters?.year!.toString() ?? '',
    };
  }
}
